<template>
  <nav class="navbar">
    <div class="navbar-brand">
      <a class="navbar-item" :href="title_link">{{ title_url }}</a>
    </div>
    <div class="navbar-menu is-active">
      <div class="navbar-start">
        <div class="navbar-item">
          <router-link :to="schedule_url">Schedule</router-link>
        </div>
        <div class="navbar-item">
          <router-link :to="thumbs_url">Thumbnails</router-link>
        </div>
      </div>
      <div class="navbar-end">
        <div class="navbar-item" v-for="ayear in years" :key="ayear">
          <router-link :to="schedule_url_for(ayear)">{{ ayear }}</router-link>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: ["year"],
  methods: {
    schedule_url_for(ayear) {
      return "/schedule/" + ayear;
    }
  },
  computed: {
    ...mapGetters(["years"]),
    title_url() {
      return "FAB Academy " + this.year + " - Final Projects";
    },
    title_link() {
      return "https://fabacademy.org/" + this.year;
    },
    schedule_url() {
      return "/schedule/" + this.year;
    },

    thumbs_url() {
      return "/thumbnails/" + this.year;
    }
  }
};
</script>

<style>
nav.navbar {
}
.navbar-brand .navbar-item {
  font-weight: bold;
}
</style>
